
import moment from 'moment';

export const formatDate = (date: number | string | null): string => {
    if (date == null) {
        return "unknown"
    }

    return moment(typeof date === 'string' ? date : Number(date)).format('MMMM Do Y')
}

/**
 * The calendar day a date picker landed on, as `YYYY-MM-DD` — what the server stores.
 *
 * `moment(epoch)` formats in the browser's own zone, which is right: the picker hands back local
 * midnight on the chosen day, so the local date *is* the choice. The bug was never here — it was
 * the server turning this string back into an instant (see backend `utils/dateOfBirth.ts`).
 *
 * Was `MM-DD-YYYY` until 2026-11-02. The server still accepts that, because a tab opened before the
 * deploy keeps sending it until it is reloaded; ISO is simply the one with no way to be misread.
 */
export const formatDateForBirth = (epoch: number): string=> {
    return moment(Number(epoch)).format('YYYY-MM-DD')
}

export const formatDateTime = (epoch: number): string => {
    return moment(Number(epoch)).format('ddd, MMMM Do - hh:mm a')
}

export const formatDateTimeToDay = (epoch: number): string => {
    return moment(Number(epoch)).format('MMMM Do')
}
